export default function useNextVideo(videos = [], isFinished = false) {
  const hasUnwatched = !!videos.some((video) => !video.isFinished);
  const firstUnwatchedVideo = videos.filter((video) => !video.isFinished)?.[0];
  const firstWatchedVideo = videos.filter((video) => video.isFinished)?.[0];
  const hasVideoInProgress = videos.some(
    (video) => video.progress !== 0 && typeof video.progress === "number"
  );

  const playButtonText = () => {
    if (
      !hasUnwatched ||
      (isFinished && !hasVideoInProgress && !firstUnwatchedVideo)
    ) {
      return "Assistir\nNovamente";
    } else if ((firstWatchedVideo && hasUnwatched) || hasVideoInProgress) {
      return "Continuar";
    } else {
      return "Assistir";
    }
  };

  const nextVideo = () => {
    const firstUnwatchedVideoIndex = videos.findIndex(
      (nextVideo) => nextVideo.id === firstUnwatchedVideo?.id
    );

    // caso não tenha um vídeo não assistido, irá abrir o primeiro vídeo e resetar o progresso do curso ("Assistir novamente")
    if (firstUnwatchedVideoIndex === -1) {
      return videos[0];
    }

    return videos[firstUnwatchedVideoIndex];
  };

  return { nextVideo, playButtonText };
}
